import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';

/**
 * Page heading variant:
 * - main: Standard page title (title only on left, actions on right)
 * - subpage: Back-navigation page title (back button + title on left, actions on right)
 */
export type PageHeadingVariant = 'main' | 'subpage';

@Component({
  selector: 'hc-page-heading',
  standalone: false,
  templateUrl: './page-heading.component.html',
  styleUrl: './page-heading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PageHeadingComponent {
  /** Visual variant */
  @Input() variant: PageHeadingVariant = 'main';

  /** Page title — alternative to ng-content projection */
  @Input() title = '';

  /** Optional subtitle/description text below the title */
  @Input() description = '';

  /**
   * Back button label (subpage variant).
   * When set, shows a back button before the title.
   * Defaults to 'Back' for subpage variant.
   */
  @Input() backLabel = 'Back';

  /**
   * Explicit back navigation route.
   * When not set, uses Location.back() (browser history).
   */
  @Input() backRoute = '';

  /** Emitted when the back button is clicked (for custom navigation) */
  @Output() back = new EventEmitter<void>();

  constructor(private location: Location) {}

  onBack(): void {
    if (this.back.observed) {
      this.back.emit();
    } else if (this.backRoute) {
      // Router navigation handled by routerLink in template
    } else {
      this.location.back();
    }
  }
}
